module.exports = __webpack_public_path__ + "static/media/menu-integrations-icon.7923a2bd.svg";